import { parse, parseAll, theme, Theme } from "@config/theme";
import { css, cx } from "linaria";
import { rem } from "polished";
import React, { HTMLAttributes } from "react";
import { ThemeSystemProps } from "theme-system";
export const CONTENT_BLOCK_MB: ThemeSystemProps<Theme>["mb"] = {
  _: "64",
  medium: "112",
  xlarge: "160"
};
type ContainerProps = Pick<ThemeSystemProps<Theme>, "mb" | "mt"> & HTMLAttributes<HTMLDivElement> & {
  as?: "div" | "section";
  variant?: "default" | "grid";
};
export const Container = React.forwardRef<HTMLElement, ContainerProps>(({
  mb,
  mt,
  className,
  as = "section",
  variant = "default",
  ...rest
}, ref) => {
  const Comp = as;
  return <Comp className={cx(className, container, parseAll({
    mb,
    mt
  }))} data-grid={variant === "grid" ? "" : undefined} ref={(ref as any)} {...rest}></Comp>;
});
const container = parse({
  position: "relative",
  width: "100%",
  mx: "auto",
  px: {
    _: "20",
    medium: "40",
    large: "160"
  }
}, "cgu0076");

require("./Container.linaria.module.css!=!../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Container.tsx");